import React from "react";
import Select from "react-select";
import { useTagAndSegment } from "../../contexts/tagAndSegment";

const SegmentBuilderCondition = ({ condition }) => {
  const {
    tagArray: tags,
    onConditionChange,
    onConditionDelete,
  } = useTagAndSegment();

  const handleTagChange = (selectedOption) => {
    onConditionChange({ 
      ...condition, 
      value: selectedOption?.value || null // Ensure null when cleared
    });
  };

  // Convert tags to react-select format
  const options = tags.map(tag => ({
    value: tag.id,
    label: tag.name
  }));

  const selectedOption = options.find(option => option.value === condition.value);

  return (
    <div className="flex items-center gap-4 mb-2 border-2 p-2 rounded w-full">
      <select className="border rounded p-2 bg-white">
        <option>{condition.field}</option>
      </select>

      <select className="border rounded p-2 bg-white">
        <option>
          {condition.operator === "isTagged"
            ? "contact is tagged"
            : condition.operator}
        </option>
      </select>

      <div className="flex flex-row items-center">
        <Select
          value={selectedOption}
          onChange={handleTagChange}
          options={options}
          placeholder="Select a tag"
          isClearable
          className={`w-64 react-select-container ${!condition.value ? 'border-red-500' : ''}`}
          classNamePrefix="react-select"
        />
        {!condition.value && (
          <p className="text-red-500 text-xs ml-1">Please select a tag</p>
        )}
      </div>

      <button
        onClick={() => onConditionDelete(condition.id)}
        className="ml-auto mr-2 text-red-600 hover:text-red-800"
      >
        ✕
      </button>
    </div>
  );
};

export default SegmentBuilderCondition;
